import { invoke, addPluginListener } from '@tauri-apps/api/core';
import { listen } from '@tauri-apps/api/event';

const NATIVE_CALL_EVENT = 'plugin:livekit-mobile://native-call-event';
const getNativeCallCapabilities = () => invoke('plugin:livekit-mobile|get_native_call_capabilities');
const connectNativeCall = (request) => invoke('plugin:livekit-mobile|connect_native_call', { payload: request });
const disconnectNativeCall = (request) => invoke('plugin:livekit-mobile|disconnect_native_call', { payload: request });
const setNativeCallMicrophoneEnabled = (request) => invoke('plugin:livekit-mobile|set_native_call_microphone_enabled', {
    payload: request,
});
const setNativeCallCameraEnabled = (request) => invoke('plugin:livekit-mobile|set_native_call_camera_enabled', {
    payload: request,
});
const setNativeCallScreenShareEnabled = (request) => invoke('plugin:livekit-mobile|set_native_call_screen_share_enabled', {
    payload: request,
});
const setNativeCallPiPEnabled = (request) => invoke('plugin:livekit-mobile|set_native_call_pip_enabled', {
    payload: request,
});
const switchNativeCallCamera = (request) => invoke('plugin:livekit-mobile|switch_native_call_camera', {
    payload: request,
});
const setNativeCallEncryptionKey = (request) => invoke('plugin:livekit-mobile|set_native_call_encryption_key', {
    payload: request,
});
const setNativeCallRemoteVideoOverlay = (request) => invoke('plugin:livekit-mobile|set_native_call_remote_video_overlay', {
    payload: request,
});
const clearNativeCallRemoteVideoOverlay = (request) => invoke('plugin:livekit-mobile|clear_native_call_remote_video_overlay', {
    payload: request,
});
const setNativeCallLocalVideoOverlay = (request) => invoke('plugin:livekit-mobile|set_native_call_local_video_overlay', {
    payload: request,
});
const clearNativeCallLocalVideoOverlay = (request) => invoke('plugin:livekit-mobile|clear_native_call_local_video_overlay', {
    payload: request,
});
const getNativeCallState = () => invoke('plugin:livekit-mobile|get_native_call_state');
const listenNativeCallSnapshot = (handler) => listen(NATIVE_CALL_EVENT, ({ payload }) => handler(payload));
const startSystemCall = (request) => invoke('plugin:livekit-mobile|start_system_call', { payload: request });
const endSystemCall = (request) => invoke('plugin:livekit-mobile|end_system_call', { payload: request });
const setSystemCallMuted = (request) => invoke('plugin:livekit-mobile|set_system_call_muted', { payload: request });
const drainPendingSystemCallActions = () => invoke('plugin:livekit-mobile|drain_pending_system_call_actions');
const fulfillAnswerCall = (uuid) => invoke('plugin:livekit-mobile|fulfill_answer_call', { payload: { uuid } });
const fulfillEndCall = (uuid) => invoke('plugin:livekit-mobile|fulfill_end_call', { payload: { uuid } });
const reportSystemCallConnected = (uuid) => invoke('plugin:livekit-mobile|report_system_call_connected', { payload: { uuid } });
const getAudioRoutes = (request) => invoke('plugin:livekit-mobile|get_audio_routes', { payload: request });
const setAudioRoute = (request) => invoke('plugin:livekit-mobile|set_audio_route', { payload: request });
const updateCallDisplay = (request) => invoke('plugin:livekit-mobile|update_call_display', { payload: request });
const onSystemCallAction = (handler) => addPluginListener('livekit-mobile', 'callkit_event', handler);

export { clearNativeCallLocalVideoOverlay, clearNativeCallRemoteVideoOverlay, connectNativeCall, disconnectNativeCall, drainPendingSystemCallActions, endSystemCall, fulfillAnswerCall, fulfillEndCall, getAudioRoutes, getNativeCallCapabilities, getNativeCallState, listenNativeCallSnapshot, onSystemCallAction, reportSystemCallConnected, setAudioRoute, setNativeCallCameraEnabled, setNativeCallEncryptionKey, setNativeCallLocalVideoOverlay, setNativeCallMicrophoneEnabled, setNativeCallPiPEnabled, setNativeCallRemoteVideoOverlay, setNativeCallScreenShareEnabled, setSystemCallMuted, startSystemCall, switchNativeCallCamera, updateCallDisplay };
